import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { reduxForm, Field } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';

import Button from 'components/common/Button';
import IconButton from 'components/common/IconButton';
import EditTextField from 'components/fields/EditTextField';
import IconPrint from 'components/icons/IconPrint';

import * as validate from 'utils/validate';

import TemplatePreviewFillFormField from './TemplatePreviewFillFormField';

const styles = () => ({
  paper: {
    marginTop: 24,
    padding: 24,
  },
  button: {
    '& + $button': {
      marginLeft: 24,
    },
  },
  iconButton: {
    marginTop: -4,
    verticalAlign: 'top',
    '$button + &': {
      marginLeft: 8,
    },
  },
  iconPrint: {
    width: 22,
    height: 20,
  },
});

function onChange(values, dispatch, props, prevValues) {
  const signatureFieldIndexes = props.template.Questions
    .map((item, index) =>
      (item['Question Type'] === 'Signature' ? index : null))
    .filter(item => item);
  if (signatureFieldIndexes.length > 0) {
    signatureFieldIndexes.forEach((fieldName) => {
      if (!prevValues.Questions || (values.Questions[fieldName] !== prevValues.Questions[fieldName])) {
        props.onSignatureChange(values.Questions[fieldName]);
      }
    });
  }
}

const TemplatePreviewFillForm = ({
  handleSubmit,
  template,
  patient,
  order,
  onSubmitCustom,
  history,
  record,
  submitting,
  business,
  variant,
  classes,
}) => {
  const lastRecordBeforeDocumentPreviewFill = record.slice().reverse()
    .find(item => item.pathname.indexOf('/print') === -1);
  const backHref = lastRecordBeforeDocumentPreviewFill
    ? lastRecordBeforeDocumentPreviewFill.pathname : '/';
  return (
    <form
      noValidate
      onSubmit={handleSubmit(onSubmitCustom(false))}
      autoComplete="off"
    >
      <Toolbar
        className={classes.gridToolbar}
        disableGutters
      >
        <Grid
          container
          spacing={24}
          alignItems="center"
          justify="space-between"
        >
          <Grid item>
            <Field
              name="Name"
              component={EditTextField}
              placeholder="Print Document Name"
              validate={[validate.required]}
            />
          </Grid>
          <Grid item>
            <Button
              variant="raised"
              className={classes.button}
              onClick={() => {
                if (variant === '_blank') {
                  window.close();
                } else {
                  history.push(backHref);
                }
              }}
            >
              {variant === '_blank' ? 'Close' : 'Cancel'}
            </Button>
            <Button
              variant="raised"
              color="primary"
              className={classes.button}
              disabled={submitting}
              onClick={patient
                ? handleSubmit(onSubmitCustom(false))
                : handleSubmit(onSubmitCustom(true))}
            >
              {patient ? 'Save' : 'Print'}
            </Button>
            {patient &&
              <IconButton
                className={classes.iconButton}
                disabled={submitting}
                tooltipContent="Print"
                onClick={handleSubmit(onSubmitCustom(true))}
              >
                <IconPrint className={classes.iconPrint} />
              </IconButton>
            }
          </Grid>
        </Grid>
      </Toolbar>
      <Paper className={classes.paper}>
        <Grid
          container
          spacing={16}
        >
          {template.Questions.map((item, index) => (
            <TemplatePreviewFillFormField
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              name={`Questions[${index}]`}
              patient={patient}
              order={order}
              business={business}
              {...item}
            />
          ))}
        </Grid>
      </Paper>
    </form>
  );
};

TemplatePreviewFillForm.propTypes = {
  variant: PropTypes.oneOf(['_blank', '_self']),
  handleSubmit: PropTypes.func.isRequired,
  onSubmitCustom: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  template: PropTypes.shape({
    Questions: PropTypes.arrayOf(PropTypes.shape({
      Text: PropTypes.string,
    })),
  }).isRequired,
  patient: PropTypes.shape({
    'Record Number': PropTypes.number.isRequired,
  }),
  order: PropTypes.shape({
    ID: PropTypes.number.isRequired,
  }),
  record: PropTypes.arrayOf(PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  })).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    paper: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    iconButton: PropTypes.string.isRequired,
    iconPrint: PropTypes.string.isRequired,
  }).isRequired,
};

TemplatePreviewFillForm.defaultProps = {
  variant: '_self',
  patient: null,
  order: null,
  business: null,
};

const mapStateToProps = store => ({
  record: store.routerParams.record,
});

export default connect(mapStateToProps)(withRouter(reduxForm({
  onChange,
  onSubmit: () => {},
  destroyOnUnmount: false,
})(
  withStyles(styles)(TemplatePreviewFillForm),
)));



// WEBPACK FOOTER //
// ./src/components/settings/TemplatePreviewFillForm/TemplatePreviewFillForm.js